// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDWlHbv8g2s0aRD5fXFdcsvTn2RyWG6AeE",
  authDomain: "bbascustomerportal.firebaseapp.com",
  projectId: "bbascustomerportal",
  storageBucket: "bbascustomerportal.appspot.com",
  messagingSenderId: "1064751855923",
  appId: "1:1064751855923:web:cac24d2cf160f4cbbee646",
  measurementId: "G-CHJZVP3G1E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

//Set persistence to local to maintain authentication state across page reloads
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Session persistence set to local.');
  })
  .catch((error) => {
    console.error('Error setting session persistence:', error);
  });

export default app;
